export default __webpack_public_path__ + "static/media/navbar-api-dark.f9817a75.svg";